import {Route, Routes} from "react-router-dom";
import {PathList} from "./Path";
import LoginScreen from "../../Screens/Login/LoginScreen";
import StripeSuccessScreen from "../../Screens/Stripe/SuccessScreen";
import StripeErrorScreen from "../../Screens/Stripe/ErrorScreen";
import UserManagementScreen from "../../Screens/UserManagementScreen/UserManagementScreen";
import TrainerManagementScreen from "../../Screens/TrainerManagementScreen/TrainerManagementScreen";
import BookingDetaileScreen from "../../Screens/BookingDetailsScreen/BookingDetaileScreen";
import BookingScreen from "../../Screens/BookingScreen/BookingScreen";
import UserDetailsPage from "../../Screens/UserManagementScreen/UserDetailsPage";
import UserFitnessDashboardPage from "../../Screens/UserManagementScreen/UserFitnessDashboardPage";
import TrainerDetails from "../../Screens/TrainerManagementScreen/TrainerDetails";
import MainLayout from "../../Screens/Layout/Layout";
import {Middleware} from "./Middleware";
import DashboardScreen from "../../Screens/Dashboard/DashboardScreen";
import NotificationScreen from "../../Screens/NotificationScreen/NotificationScreen";
import FAQs from "../../Screens/FAQs/FAQs";
import AppIssue from "../../Screens/AppIssue/AppIssue";
import SettingScreen from "../../Screens/Setting/SettingScreen";
import PaymentHistoryScreen from "../../Screens/PaymentHistoryScreen/PaymentHistoryScreen";
import TrainingPlanDetails from "../../Screens/TrainingPlanDetails/TrainingPlanDetails";
import ManageNewRequests from "../../Screens/NewUpdate/NewUpdates";
import PromoCodeScreen from "../../Screens/PromoCode/PromoCodeScreen";
import CreatePromoCodeForm from "../../Screens/PromoCode/CreatePromoCodeForm";
import EditPromoCodeScreen from "../../Screens/PromoCode/EditPromoCodeScreen";

import PlansScreen from "../../Screens/Plans/PlansScreen";
import PlansAddScreen from "../../Screens/Plans/PlansAddScreen";
import PlansEditScreen from "../../Screens/Plans/PlansEditScreen";

import BadgesScreen from "../../Screens/Badges/BadgesScreen";
import AddBadgeScreen from "../../Screens/Badges/AddBadgeScreen";
import EditBadgeScreen from "../../Screens/Badges/EditBadgeScreen";

import ChallengesScreen from "../../Screens/Challenges/ChallengesScreen";
import AddChallengeScreen from "../../Screens/Challenges/AddChallengeScreen";
import EditChallengeScreen from "../../Screens/Challenges/EditChallengeScreen";
import ConvertChallengeScreen from "../../Screens/Challenges/ConvertChallengeScreen";

import ActivityLogsScreen from "../../Screens/Activity/ActivityLogsScreen";
import WhoopRequestsScreen from "../../Screens/Activity/WhoopRequestsScreen";
import ContractAgreementScreen from "../../Screens/Activity/ContractAgreementScreen";

export default function RoutesList() {
    return (
        <Routes>
            <Route path={PathList.Login} element={<LoginScreen/>}/>
            <Route path={PathList.StripeSuccess} element={<StripeSuccessScreen/>}/>
            <Route path={PathList.StripeError} element={<StripeErrorScreen/>}/>
            <Route
                path={PathList.Dashboard}
                element={
                    <Middleware children={<MainLayout element={<DashboardScreen/>}/>}/>
                }
            />
            <Route
                path={PathList.Booking}
                element={
                    <Middleware children={<MainLayout element={<BookingScreen/>}/>}/>
                }
            />
            <Route
                path={PathList.UserManagement}
                element={
                    <Middleware
                        children={<MainLayout element={<UserManagementScreen/>}/>}
                    />
                }
            />
            <Route
                path={PathList.Trainer}
                element={
                    <Middleware
                        children={<MainLayout element={<TrainerManagementScreen/>}/>}
                    />
                }
            />
            <Route
                path={PathList.Notification}
                element={
                    <Middleware
                        children={<MainLayout element={<NotificationScreen/>}/>}
                    />
                }
            />
            <Route
                path={PathList.request}
                element={
                    <Middleware
                        children={<MainLayout element={<ManageNewRequests/>}/>}
                    />
                }
            />
            <Route
                path={PathList.PlanDetails}
                element={
                    <Middleware
                        children={<MainLayout element={<TrainingPlanDetails/>}/>}
                    />
                }
            />

            <Route
                path={`${PathList.Booking_Details}/:id`}
                element={
                    <Middleware
                        children={<MainLayout element={<BookingDetaileScreen/>}/>}
                    />
                }
            />
            <Route
                path={`${PathList.UserDetails}/:id`}
                element={
                    <Middleware children={<MainLayout element={<UserDetailsPage/>}/>}/>
                }
            />

            <Route
                path={`${PathList.UserFitnessDashboard}/:id`}
                element={
                    <Middleware children={<MainLayout element={<UserFitnessDashboardPage/>}/>}/>
                }
            />

            <Route
                path={`${PathList.TrainerDetails}/:id`}
                element={
                    <Middleware children={<MainLayout element={<TrainerDetails/>}/>}/>
                }
            />
            <Route
                path={`${PathList.PaymentHistory}`}
                element={
                    <Middleware
                        children={<MainLayout element={<PaymentHistoryScreen/>}/>}
                    />
                }
            />
            <Route
                path={PathList.FAQs}
                element={<Middleware children={<MainLayout element={<FAQs/>}/>}/>}
            />
            <Route
                path={PathList.AppIssue}
                element={
                    <Middleware children={<MainLayout element={<AppIssue/>}/>}/>
                }
            />
            <Route
                path={PathList.Setting}
                element={
                    <Middleware children={<MainLayout element={<SettingScreen/>}/>}/>
                }
            />
            <Route
                path={PathList.PromoCode}
                element={
                    <Middleware children={<MainLayout element={<PromoCodeScreen/>}/>}/>
                }
            />
            <Route
                path={PathList.PromoCodeCreate}
                element={
                    <Middleware children={<MainLayout element={<CreatePromoCodeForm/>}/>}/>
                }
            />

            <Route
                path={`${PathList.EditPromoCode}/:id`}
                element={
                    <Middleware children={<MainLayout element={<EditPromoCodeScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.Plans}
                element={
                    <Middleware children={<MainLayout element={<PlansScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.AddPlan}
                element={
                    <Middleware children={<MainLayout element={<PlansAddScreen/>}/>}/>
                }
            />

            <Route
                path={`${PathList.EditPlan}/:id`}
                element={
                    <Middleware children={<MainLayout element={<PlansEditScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.Badge}
                element={
                    <Middleware children={<MainLayout element={<BadgesScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.AddBadge}
                element={
                    <Middleware children={<MainLayout element={<AddBadgeScreen/>}/>}/>
                }
            />

            <Route
                path={`${PathList.EditBadge}/:id`}
                element={
                    <Middleware children={<MainLayout element={<EditBadgeScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.challenge}
                element={
                    <Middleware children={<MainLayout element={<ChallengesScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.AddChallenge}
                element={
                    <Middleware children={<MainLayout element={<AddChallengeScreen/>}/>}/>
                }
            />

            <Route
                path={`${PathList.EditChallenge}/:id`}
                element={
                    <Middleware children={<MainLayout element={<EditChallengeScreen/>}/>}/>
                }
            />

            <Route
                path={`${PathList.ConvertChallenge}/:id`}
                element={
                    <Middleware children={<MainLayout element={<ConvertChallengeScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.ActivityLogs}
                element={
                    <Middleware children={<MainLayout element={<ActivityLogsScreen/>}/>}/>
                }
            />

            <Route
                path={PathList.WhoopRequests}
                element={
                    <Middleware children={<MainLayout element={<WhoopRequestsScreen/>}/>}/>
                }
            />
            <Route
                path={PathList.ContractAgreement}
                element={
                    <Middleware children={<MainLayout element={<ContractAgreementScreen/>}/>}/>
                }
            />
        </Routes>
    );
}
